import React, { useState, cloneElement, isValidElement } from 'react';
import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import type { ModalProps } from 'antd';

export interface MyModalConfirmProps {
  title: React.ReactNode;
  onConfirm?: () => void | Promise<void>;
  onCancel?: () => void;
  okText?: React.ReactNode;
  cancelText?: React.ReactNode;
  okButtonProps?: ModalProps['okButtonProps'];
  cancelButtonProps?: ModalProps['cancelButtonProps'];
  icon?: React.ReactNode;
  disabled?: boolean;
  children?: React.ReactNode;
}

const MyModalConfirm: React.FC<MyModalConfirmProps> = ({
  title,
  onConfirm,
  onCancel,
  okText = 'Yes',
  cancelText = 'No',
  okButtonProps,
  cancelButtonProps,
  icon = <ExclamationCircleOutlined style={{ color: '#faad14' }} />,
  disabled = false,
  children,
}) => {
  const [visible, setVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    if (!disabled) {
      setVisible(true);
    }
  };

  const handleOk = async () => {
    if (onConfirm) {
      setConfirmLoading(true);
      try {
        await onConfirm();
      } finally {
        setConfirmLoading(false);
      }
    }
    setVisible(false);
  };

  const handleCancel = () => {
    onCancel?.();
    setVisible(false);
  };

  const triggerElement = isValidElement(children)
    ? cloneElement(children as React.ReactElement<any>, {
      onClick: handleClick,
    })
    : <span onClick={handleClick}>{children}</span>;

  return (
    <>
      {triggerElement}
      <Modal
        open={visible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText={okText}
        cancelText={cancelText}
        okButtonProps={okButtonProps}
        cancelButtonProps={cancelButtonProps}
        confirmLoading={confirmLoading}
        width={416}
        closable={false}
      >
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
          <span style={{ fontSize: 22 }}>{icon}</span>
          <div style={{ flex: 1, paddingTop: 2 }}>{title}</div>
        </div>
      </Modal>
    </>
  );
};

export default MyModalConfirm;
